(() => {
  const loaderUrl = 'https://webforms.pipedrive.com/f/loader';
  let loaderPromise;

  const loadPipedrive = () => {
    if (loaderPromise) return loaderPromise;

    loaderPromise = new Promise((resolve, reject) => {
      const existingLoader = document.querySelector(`script[src="${loaderUrl}"]`);

      if (existingLoader) {
        resolve();
        return;
      }

      const loader = document.createElement('script');
      loader.src = loaderUrl;
      loader.async = true;
      loader.addEventListener('load', () => {
        loader.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      loader.addEventListener('error', reject, { once: true });
      document.head.appendChild(loader);
    });

    return loaderPromise;
  };

  const closeModal = (dialog) => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pipedrive-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.pipedriveModalOpen);
      if (!dialog) return;

      event.preventDefault();
      dialog._returnFocusTo = opener;

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      loadPipedrive().catch(() => {
        dialog.querySelector('[data-pipedrive-error]')?.removeAttribute('hidden');
      });
      return;
    }

    const closer = event.target.closest('[data-pipedrive-modal-close]');
    if (closer) {
      const dialog = closer.closest('.pipedrive-form-modal');
      if (dialog) closeModal(dialog);
      return;
    }

    if (event.target.matches('.pipedrive-form-modal')) {
      closeModal(event.target);
    }
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('.pipedrive-form-modal')) return;
    event.target._returnFocusTo?.focus();
  }, true);
})();
